export const styles = (theme) => ({

closeButton:{
    width: "30px",
    height: "30px",
    background: "#242424",
    minWidth: "inherit",
    // position: "absolute",
    right: "0px",
    float:"right",
    "& svg":{
        fontSize: "17px",
    }
},
updateMatchesContainer:{
    position:"absolute",
    bottom:"0"
},
hisContainer:{
    position:"relative",
    "& .hisinnerContainer":{
        maxHeight:"30vh",
        overflow:"auto",
        position:"absolute",
    }
    
},
emptyMsg:{
    textAlign:"left", paddingBottom:"10px"
},
dataViewContainer:{
    "& .MuiPaper-rounded":{
        background: "#353535", 
    },
    "& > div.MuiPaper-rounded":{
        height:"230px",
    },
    "& .MuiBox-root .MuiPaper-root":{
        height: "calc(100% - 45px) !important",
    },
    "& .popupWindow":{
        height: "220px !important",
    },
    "& .popupData":{
        alignItems:"center",
    }
},
modalPopupWrap:{
    "& .MuiDialog-paper":{
        minWidth:"1000px",
        textAlign:"left",
        maxWidth:"1024px",
        "& .waveImageInBuilt":{
            top:"10px"
          }
    },
    "& .MuiDialogTitle-root": {
        padding: "8px 12px 0px 12px",
    },
},
artistName:{
    fontSize: ".9em",
},
headTag:{
    fontSize: "1.2em",
    fontWeight: "400",
    color: "#fff",
    lineHeight: "1",
    maxWidth:"98%",
    paddingTop:"10px",
},
playerPopContainer:{
    marginTop:"20px",
    "& > div":{
        paddingLeft:"0 !important",
        margin:"0",
        width:"100%",
    },
    "& .duration-container":{
        right: "12px",
        marginTop: "40px",
    },
    "& .popupWave":{
        height:"57px !important",
    },
    "& .MuiSlider-root":{
        marginTop: "0",
        marginLeft: "5px",
        marginRight: "15px",
    },
    "& .MuiCircularProgress-indeterminate":{
        width: "20px !important", 
       height: "20px !important",
        margin: "20px auto",
        position: "relative !important",
        color: "#fff !important",
   }
},

innerPadding:{
    "& .popupProgress ":{
        height: "57px",
        "& .waveImage":{
            // filter: "brightness(0) invert(1)",
            width: "100%",
            height: "57px",
            position: "absolute",
            imageRendering: "pixelated !important",
        }
    },
    paddingLeft:"18px",
},
imgContainer:{
    padding:"10px 20px 20px 0px",
    "& img":{
        boxShadow:"0 0 5px #000",
    }
}
});